// extracted by mini-css-extract-plugin
export default {"group":"PropertyLocation_group__KtuWE","label":"PropertyLocation_label__g151Q","inputStyle":"PropertyLocation_inputStyle__JnHtV"};